export default __webpack_public_path__ + "static/2303-91c64df7c6bb0e8afb8f2c9a7d31086c.gif";